import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export type AnalyticAttributes = { component: string; path: string; url: string; type: string; cta?: string };

const trackDocumentationLink = createTrackerForCategory('Documentation Links');
export const trackDocumentationLinkClicked = (targetUrl: string, analyticsAttributes: AnalyticAttributes) =>
  trackDocumentationLink('Documentation Link Clicked', { targetUrl, ...analyticsAttributes });
